import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"
import Title from "../../common/Title"
import Loader from "../../common/Loader"
import PDFReaderModal from "../../common/PDFReaderModal"
import {
  onStartLoading,
  onFetchL2LShopOrders,
  fetchOrderStatuses,
  getOrderDetails,
  updateOrderStatus,
  clearOrderUpdate,
  updateOrderExtentionByAccount,
  clearTransferOrder,
  onLoadBarcodePDF,
  getBarcodePDF,
  getBarcodesPDFList,
  clearBarcodePDF,
  printAllPDFs,
  clearBarcodesPDFList,
  clearOrderIdsForPrint,
  clearPDFListRequest,
} from "../../../actions"
import "./style.scss"
import L2LShopOrdersList from "./L2LShopOrdersList"
import OrderHistoryModal from "../../common/OrderHistoryModal"
import { getFormatedDate } from "../../../utils"
import YesNoModal from "../../common/YesNoModal"
import OrderDelayModal from "../../common/OrderDelayModal"
import NotificationModal from "../../common/NotificationModal"
import TransferOrderModal from "../../common/TransferOrderModal"
import { PDFDocument, rgb } from "pdf-lib"

const L2LShopOrdersListScreen = ({ history }) => {
  const dispatch = useDispatch()
  const {
    authenticated,
    isLoading,
    shopOrderList,
    orderDetails,
    ordersStatusesArr,
    orderStatusUpdateSuccess,
    orderStatusUpdateByAccountSuccess,
    orderStatusUpdateByAccountFail,
    stationsList,
    transferOrderSuccess,
    transferOrderFail,
    file,
    packageNumbersForPrint,
    barcodePDFList,
    isPrintPDFListSuccess,
    isPrintPDFListFail,
  } = useSelector((state) => ({
    authenticated: state.users.authenticated,
    isLoading: state.orders.isLoading,
    shopOrderList: state.orders.shopOrderList,
    orderDetails: state.orders.orderDetails,
    stationsList: state.station.stationsList,
    ordersStatusesArr: state.orderStatuses.ordersStatusesArr,
    orderStatusUpdateSuccess: state.orders.orderStatusUpdateSuccess,
    orderStatusUpdateByAccountSuccess:
      state.orders.orderStatusUpdateByAccountSuccess,
    orderStatusUpdateByAccountFail: state.orders.orderStatusUpdateByAccountFail,
    transferOrderSuccess: state.orders.transferOrderSuccess,
    transferOrderFail: state.orders.transferOrderFail,
    file: state.barcode.file,
    packageNumbersForPrint: state.barcode.packageNumbersForPrint,
    barcodePDFList: state.barcode.barcodePDFList,
    isPrintPDFListSuccess: state.barcode.isPrintPDFListSuccess,
    isPrintPDFListFail: state.barcode.isPrintPDFListFail,
  }))

  const [state, setState] = useState({
    orderExternalNumbers: null,
    isShowHistory: false,
    isShowPDF: false,
    packageNumber: null,
    showCancelOrderModal: false,
    showOrderDelayModal: false,
    selectedOrder: null,
    currentOrderInLockerDate: null,
    isShowTransferOrder: false,
  })

  useEffect(() => {
    if (!authenticated) {
      history.push("/")
    } else {
      dispatch(onStartLoading())
      dispatch(fetchOrderStatuses())
      dispatch(onFetchL2LShopOrders())
    }
  }, [authenticated, history, dispatch])

  useEffect(() => {
    if (orderStatusUpdateSuccess) {
      dispatch(onFetchL2LShopOrders())
      dispatch(clearOrderUpdate())
    }
  }, [orderStatusUpdateSuccess, dispatch])

  useEffect(() => {
    if (barcodePDFList.length > 0) {
      dispatch(printAllPDFs(barcodePDFList))
    }
  }, [barcodePDFList, dispatch])

  useEffect(() => {
    if (isPrintPDFListSuccess) {
      dispatch(clearBarcodesPDFList())
      dispatch(clearOrderIdsForPrint())
      dispatch(clearPDFListRequest())
    }
  }, [isPrintPDFListSuccess, dispatch])

  const refreshTable = () => {
    dispatch(onFetchL2LShopOrders())
  }

  const onClickOrderHistory = async (order) => {
    const currentOrder = shopOrderList.find(
      (o) => o.orderNumber === order.original.orderNumber
    )
    await dispatch(getOrderDetails(currentOrder.id))
    setState((prev) => ({ ...prev, isShowHistory: true }))
  }

  const onListIconClick = (order) => {
    const currentNumbers = order.original.externalOrderNumber.split(",")
    setState((prev) => ({ ...prev, orderExternalNumbers: currentNumbers }))
  }

  const confirmCancelOrder = () => {
    dispatch(updateOrderStatus(state.selectedOrder.id, 6))
    setState((prev) => ({ ...prev, showCancelOrderModal: false }))
  }

  const extendPackageClick = (order) => {
    const currentOrder = shopOrderList.find((o) => o.id === order.id)
    setState((prev) => ({
      ...prev,
      showOrderDelayModal: true,
      selectedOrder: order,
      currentOrderInLockerDate: currentOrder.inLockerExtentionDate,
    }))
  }

  const updateInLockerDate = (selectedDate) => {
    const dateWithTime = new Date(selectedDate)
    dateWithTime.setHours(23, 0, 0)
    const unixTimestamp = Math.floor(dateWithTime.getTime() / 1000)
    dispatch(
      updateOrderExtentionByAccount(state.selectedOrder.id, unixTimestamp)
    )
  }

  const onCloseMsg = () => {
    dispatch(clearOrderUpdate())
    refreshTable()
    setState((prev) => ({
      ...prev,
      showOrderDelayModal: false,
    }))
  }

  const onTransferOrderClick = (order) => {
    setState((prev) => ({
      ...prev,
      isShowTransferOrder: true,
      selectedOrder: order,
    }))
  }

  const onCloseTransferOrderMsg = () => {
    dispatch(clearTransferOrder())
    setState({ isShowTransferOrder: false })
  }

  const onCancelOrderClick = (order) => {
    setState((prev) => ({
      ...prev,
      showCancelOrderModal: true,
      selectedOrder: order,
    }))
  }

  if (isLoading) {
    return (
      <div>
        <Title text="רשימת הזמנות" />
        <Loader show={isLoading} />
      </div>
    )
  }

  const onPDFClick = (order) => {
    setState({
      isShowPDF: true,
      packageNumber: order.original.packageNumber,
    })

    dispatch(onLoadBarcodePDF())
    dispatch(getBarcodePDF(order.original.packageNumber))
  }

  const printAllSelectedBarcodes = () => {
    if (packageNumbersForPrint.length > 0) {
      dispatch(getBarcodesPDFList(packageNumbersForPrint))
    }
  }

  return (
    <div className="l2lShopOrdersList">
      <Title text="רשימת הזמנות" />
      {ordersStatusesArr?.length > 0 ? (
        <L2LShopOrdersList
          onPDFClick={(order) => onPDFClick(order)}
          printAllSelectedBarcodes={() => printAllSelectedBarcodes()}
          onHistoryClick={onClickOrderHistory}
          onListIconClick={onListIconClick}
          refreshTable={refreshTable}
          extendPackageClick={extendPackageClick}
          onTransferOrderClick={onTransferOrderClick}
          onCancelOrderClick={(order) => onCancelOrderClick(order)}
        />
      ) : (
        "Loading..."
      )}

      <OrderHistoryModal
        isShow={state.isShowHistory}
        order={orderDetails}
        setViewHistory={() =>
          setState((prev) => ({ ...prev, isShowHistory: false }))
        }
        statuses={ordersStatusesArr}
        getFormatedDate={getFormatedDate}
      />

      <OrderDelayModal
        key={state.selectedOrder?.id}
        isOpen={state.showOrderDelayModal}
        isClose={() =>
          setState((prev) => ({ ...prev, showOrderDelayModal: false }))
        }
        submitDate={updateInLockerDate}
        inLockerDate={state.currentOrderInLockerDate}
      />

      {state.isShowTransferOrder ? (
        <TransferOrderModal
          stations={stationsList}
          orderId={state.selectedOrder?.id}
          onCloseClick={() => setState({ isShowTransferOrder: false })}
        />
      ) : null}
      <PDFReaderModal
        show={state.isShowPDF && file}
        file={file}
        onOkClick={() => {
          dispatch(clearBarcodePDF())
          setState({ isShowPDF: false })
        }}
      />
      <YesNoModal
        show={state.showCancelOrderModal}
        title={"מחיקת הזמנה"}
        text={"?האם אתה בטוח שברצונך לבטל הזמנה זו"}
        onYesClick={confirmCancelOrder}
        onNoClick={() =>
          setState((prev) => ({ ...prev, showCancelOrderModal: false }))
        }
      />

      <NotificationModal
        show={orderStatusUpdateByAccountSuccess}
        title={" עדכון הזמנה"}
        text={"הזמנה עודכנה בהצלחה"}
        onOkClick={onCloseMsg}
      />

      <NotificationModal
        extraClass="msg-error"
        show={orderStatusUpdateByAccountFail}
        title={" עדכון הזמנה"}
        text={"עדכון הזמנה נכשל"}
        onOkClick={onCloseMsg}
      />

      <NotificationModal
        extraClass="success"
        show={transferOrderSuccess}
        text={"בקשה להעברת הזמנה לעמדה אחרת התקבלה בהצלחה"}
        onOkClick={onCloseTransferOrderMsg}
      />
      <NotificationModal
        type={"error"}
        show={transferOrderFail}
        text={" .שגיא, בקשה לא התקבלה "}
        onOkClick={onCloseTransferOrderMsg}
      />
    </div>
  )
}

export default L2LShopOrdersListScreen
